import React from 'react';
import cc from 'classcat';
import styles from './styles.module.scss';

interface Props {
  title: string;
  subheading: string;
  phone: string;
  consultantName?: string;
  backgroundImage?: string;
}

const TourBookingCta = ({ title, subheading, phone, consultantName, backgroundImage }: Props) => {
  const firstName = consultantName?.split(' ')?.[0] || 'us';

  return (
    <div className={cc([
      'sectionWrapper section-purple',
      styles.ctaWrapper,
      backgroundImage && styles.backgroundImagePresent
    ])}>
      {backgroundImage && (
        <div className={styles.backgroundImage}>
          <img src={backgroundImage} alt={title} />
        </div>
      )}
      <div className="container">
        <div className={styles.ctaContainer}>
          <div className={styles.ctaText}>
            <h3>{title}</h3>
            <p>{subheading}</p>
          </div>

          <div className={styles.ctaButtons}>
              {phone && (
                  <a href={`tel:${phone!.replace(/[^\d\+]/g, '')}`} title={'Click to call ' + firstName + ' to book a tour'} className={'newStyleButtonOverrideSolid'}>
                     Book a tour with {firstName}
                  </a>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourBookingCta;

